/*
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 * ZERO CZY PUSTO — rozróżnienie, na którym stoi wiarygodność całego produktu
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * Backend liczy sumy agregatami SQL. Suma z pustego zbioru wynosi 0, więc API zwraca
 * `total_sales_grosze: 0` zarówno wtedy, gdy sprzedaż NAPRAWDĘ wyniosła zero, jak i wtedy, gdy
 * w źródle nie było ANI JEDNEGO wiersza do zsumowania. Te dwie sytuacje wyglądają w odpowiedzi
 * identycznie, a znaczą coś zupełnie innego:
 *
 *   ZERO   — zmierzyliśmy i wyszło zero. To sygnał biznesowy: ktoś powinien zadzwonić.
 *   PUSTO  — nie zmierzyliśmy niczego. To sygnał techniczny: coś jest nie tak z zasilaniem.
 *
 * Pomylenie ich kosztuje albo niepotrzebny telefon do restauracji, albo — gorzej — spokój tam,
 * gdzie trzeba było zareagować.
 *
 * ROZSTRZYGA LICZBA WIERSZY, NIE WARTOŚĆ. Jeżeli źródło zwróciło szkoły (albo zamówienia),
 * a ich wartość wynosi zero, to jest prawdziwe zmierzone zero i tak je pokazujemy. Dopiero brak
 * jakichkolwiek wierszy oznacza, że nie było czego liczyć.
 */

export interface ZiarnoWyniku {
  /** Liczba wierszy najniższego ziarna (np. zamówień). null = nie wiadomo. */
  wierszy: number | null;
  /** Liczba bytów w rozbiciu (np. szkół). null = nie wiadomo. */
  bytow: number | null;
}

/**
 * Czy odpowiedź źródła jest PUSTYM ZBIOREM, a nie zmierzonym zerem.
 *
 * Świadomie wymaga, żeby OBIE liczebności były zerowe. Sam brak bytów w rozbiciu przy niezerowej
 * liczbie wierszy oznaczałby błąd złączenia, a nie pustkę — i zasługuje na inną diagnozę.
 */
export function czyPustyZbior({ wierszy, bytow }: ZiarnoWyniku): boolean {
  return wierszy === 0 && bytow === 0;
}

/**
 * Wartość do wyświetlenia. Zwraca null (czyli „brak danych") wtedy i tylko wtedy, gdy zbiór jest
 * pusty albo wartości w ogóle nie znamy. Nigdy nie zamienia prawdziwego zera na brak.
 */
export function wartoscDoPokazania(wartosc: number | null | undefined, ziarno: ZiarnoWyniku): number | null {
  if (wartosc === null || wartosc === undefined) return null;
  if (czyPustyZbior(ziarno)) return null;
  return wartosc;
}
